import * as service from './service'
export default {
  namespace: 'acceleratorCardPurchaseDetail',
  state: {
    listData: [],
    detailData: {}
  },
  effects: {
    * getOrderList ({ payload }, { call, put }) {
      const res = yield call(service.getOrderList, payload)
      yield put({
        type: 'save',
        payload: {
          listData: res.data.data
        }
      })
      return res.data
    },
    * getDetail ({ payload }, { call, put }) {
      const res = yield call(service.getDetail, payload)
      yield put({
        type: 'save',
        payload: {
          detailData: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
